<template>
  <div id="products-list">
    <div class="title">
      <font-awesome-icon :icon="faBox" class="icon" />
      <h1>{{ t('PRODUCTS') }}</h1>

      <router-link :to="applyParams(PATHS.PRODUCT_EDITOR, '')">
        <div class="add-btn">
          <cross white />
        </div>
      </router-link>
    </div>

    <div class="list" ref="listRef">
      <div class="row">
        <div
          class="col col-xs-12 col-md-6 col-lg-4"
          v-for="(col, i) in itemsGrid"
          :key="i"
        >
          <div
            v-for="item in itemsGrid[i]"
            :key="item.id"
            class="item"
          >
            <div class="box">
              <div class="controls">
                <router-link :to="applyParams(PATHS.PRODUCT_EDITOR, item.id)">
                  <font-awesome-icon :icon="faPenAlt" class="icon" />
                </router-link>
                <font-awesome-icon :icon="faTrashAlt" class="icon" @click="removeProduct(item.id)" v-if="canRemove" />
              </div>

              <router-link :to="applyParams(PATHS.PRODUCT_EDITOR, item.id)">
                <h3>{{ item.name }}</h3>
                <div class="img-holder" v-if="!!item.image">
                  <img :src="item.image.url" :alt="item.name" />
                </div>
              </router-link>
              <p>{{ item.description }}</p>
              <br />
              <p><strong>{{ addCommas(item.price) }} VNĐ</strong></p>
              <div class="date">{{ moment(item.updatedAt).format(`${locale === 'en' ? 'DD MMM, YYYY' : 'DD [tháng] MM, YYYY'} | HH:ss`) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed, onUnmounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import moment from 'moment';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBox, faTrashAlt, faPenAlt } from '@fortawesome/pro-duotone-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import Cross from '@/components/Cross';

import PATHS from '@/consts/paths';
import PERMISSIONS from '@/consts/permissionCodes';
import { applyParams, addCommas } from '@/helpers';
import { hasPermissions } from '@/helpers/permission';

import ProductsService from './ProductsService';

export default {
  name: 'ProductsList',
  components: {
    FontAwesomeIcon,
    Cross
  },
  setup() {
    const { t, locale } = useI18n();
    const store = useStore();

    const listRef = ref(null);
    const filters = computed(() => store.state.products.filters);

    const canRemove = computed(() => hasPermissions([PERMISSIONS.ADMIN_MANAGE_PRODUCT]));

    const calculateItemHeightScore = (item) => {
      let h = 0;
      if (item?.image) h += 300;
      if (item?.description) h += item.description.length;

      return h;
    };

    const items = computed(() => store.state.products.items);
    const itemsGrid = computed(() => {
      let n = 3;
      if (store.state.app.isTablet) {
        n = 2;
      } else if (store.state.app.isMobile) {
        n = 1;
      }

      const stacks = Array(n).fill().map(() => []);
      const stackHeights = Array(n).fill(0);

      for (let i = 0; i < items.value.length; i += 1) {
        const minStack = stackHeights.indexOf(Math.min(...stackHeights));
        stacks[minStack].push({ ...items.value[i] });
        stackHeights[minStack] += calculateItemHeightScore(items.value[i]);
      }

      return stacks;
    });

    const removeProduct = async (id) => {
      try {
        await ProductsService.removeProduct(id);
        store.dispatch('products/getProducts', { append: false });
        store.dispatch('flash/info', 'PRODUCT_SUCCESSFULLY_REMOVED');
      } catch(e) {
        store.dispatch('flash/error', e.message);
      }
    };

    const watchLoadMore = () => {
      if (!listRef.value) return;

      const y = window.scrollY;
      const h = $(listRef.value).height();

      if (y + 200 > h) {
        store.dispatch('products/applyFilters', {
          page: filters.value.page + 1
        });
      }
    };

    watch(filters, () => {
      store.dispatch('products/getProducts', { append: false });
    });

    onMounted(() => {
      store.dispatch('products/getProducts', { append: false });

      $(window).on('scroll', watchLoadMore);
    });

    onUnmounted(() => {
      $(window).off('scroll', watchLoadMore);
    });

    return {
      t,
      faBox,
      faPlus,
      itemsGrid,
      PATHS,
      faTrashAlt,
      faPenAlt,
      removeProduct,
      applyParams,
      canRemove,
      moment,
      locale,
      listRef,
      addCommas
    };
  }
};
</script>

<style lang="scss">
@use "~@/assets/scss/colors" as *;

#products-list {
  .list {
    .item {
      .box {
        .controls {
          .toggle-input {
            .toggle-wrapper {
              &.active {
                background-color: $blue;
              }
            }
          }
        }

        .date {
          color: $grey;
          margin-top: 10px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
